import React, { useState } from 'react';
import { resizeFile } from '../../../assets/js/imageReSizer';
import { updatePost } from '../../../firebase';

function ViewPost({ post, user }) {
    const [comment, setComment] = useState("");
    const [imgSrc, setImgSrc] = useState("");
    const [imgNo, setImgNo] = useState(0);

    const saveImage = async (file) => {
        try {
            const image = await resizeFile(file);
            setImgSrc(image);
        } catch (err) {
            console.log(err);
        }
    }

    const addComment = () => {
        let newComment = {
            username: user.name, created: new Date().getTime(), post: comment,
            imgSrc: imgSrc
        };
        let tempComment = [];
        if (post.val.comment) {
            tempComment = [...post.val.comment, newComment]
        } else {
            tempComment.push(newComment);
        }

        updatePost(post.key, {
            ...post.val,
            comment: [...tempComment],
            lastUpdated: new Date().getTime()
        });
        setComment("");
        setImgSrc("");
        document.getElementById("imgComment").value = "";
    }

    const slide = (val) => {
        if (imgNo === 0 && val === -1) {
            setImgNo(post.val.imgSrc.length-1);
        } else if (imgNo === post.val.imgSrc.length-1 && val === 1) {
            setImgNo(0);
        } else {
            setImgNo(pre => (pre + val));
        }
    }

    return (
        <div className="modal fade" id="viewPost" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                {post && post.val ? <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">{post?.val?.userName}</h5>
                        <i className='bi bi-x bx-sm' style={{ cursor: "pointer" }} data-bs-dismiss="modal" aria-label="Close"
                        onClick={()=>setImgNo(0)}></i>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">
                            <div className="row gy-2">
                                <div className="col-12">
                                    {(post.val.imgSrc && post.val.imgSrc.length > 0) && <div style={{ background: "#6c757dad", borderRadius: "3px" }}>
                                        <button className="btn btn-sm btn-secondary" type="button" 
                                        style={{float:"left"}} onClick={() => slide(-1)}>
                                            &lt;
                                        </button>
                                        <button className="btn btn-sm btn-secondary" type="button" 
                                        style={{float:"right"}}  onClick={() => slide(1)}>
                                            &gt;
                                        </button>
                                        <img src={post.val.imgSrc[imgNo]} className='img-fluid' alt="..." />
                                        
                                    </div>}
                                    <div className="mt-1 p-1" style={{ background: "#166875", color: "#fff" }}>
                                        {post.val.post && <i className="h6 text-wrap" >{post.val.post}</i>}
                                    </div>
                                </div>
                                {user && <div className="col-12">
                                    <textarea className="form-control" rows="2"
                                        placeholder="Comments"
                                        value={comment} onChange={(e) => setComment(e.target.value)} />
                                    <input type="file" id="imgComment" accept="image/*" onChange={(e) => saveImage(e.target.files[0])} />
                                    <button className="btn btn-sm btn-warning m-2"
                                        disabled={!comment && !imgSrc}
                                        onClick={() => addComment()}>Comment</button>
                                </div>}
                                {(post.val.comment && post.val.comment.length > 0) && <div className="col-12">
                                    {post.val.comment.sort((a, b) => b.created - a.created)
                                        .map((c, index) => <div key={index} className="text-start">
                                            <i>{new Date(c.created).toLocaleString()} {c.username}:</i>
                                            <hr />
                                            <p style={{ whiteSpace: "pre-line" }}>{c.post}</p>
                                            {c.imgSrc && <img src={c.imgSrc} alt="query img" className="img-fluid" />}
                                        </div>)}
                                </div>}
                            </div>
                        </div>

                    </div>
                    <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
                        {user && user.id === post.val.id && <button type="button" className="btn btn-sm btn-danger"
                            data-bs-dismiss="modal" aria-label="Close"
                            onClick={() => {updatePost(post.key, null);setImgNo(0)}}>Delete</button>}
                        <i className="h6">created: {post?.val?.created}</i>
                    </div>
                </div> : null}
            </div>
        </div>

    );
}

export default React.memo(ViewPost);